export const BAVEL_ROLES = {
    ACCEPT_REJECT_POLINES: 'ACCEPTREJECTPOLINES',
    ADVANCED_CATALOGUE: 'ADVANCEDCATALOGUE',
    BILLBACK_RECEIVED: 'BILLBACK_RECEIVED',
    BILLBACK_SENT: 'BILLBACK_SENT',
    CATALOGUE: 'CATALOGUE',
    CLIENT_SUPPLIER: 'ClientSupplier',
    CONTRACTS: 'Contracts',
    DOC_ATTACHMENTS: 'DOCATTACHMENTS',
    EBILLING: 'EBILLING',
    EPAYMENTS_CLIENT_TRAVEL: 'EPAYMENTS_CLIENT_TRAVEL',
    ESP: 'ESP',
    ESTAB: 'Estab',
    FALCON_LITTLE: 'FALCON_LITTLE',
    FN_ADV_CTLG_CATALOGUE: 'FN_ADV_CTLG_CATALOGUE',
    FN_ADV_CTLG_IMPORT: 'FN_ADV_CTLG_IMPORT',
    FN_CONTRACTS: 'FN_CONTRACTS',
    FN_CTLG_CATALOGUES: 'FN_CTLG_CATALOGUES',
    FN_CTLG_FAMILIES: 'FN_CTLG_FAMILIES',
    FN_CTLG_PRICE_LIST: 'FN_CTLG_PRICE_LIST',
    FN_DA_RECEIVED_DOCUMENTS: 'FN_DA_RECEIVED_DOCUMENTS',
    FN_DA_SENT_DOCUMENTS: 'FN_DA_SENT_DOCUMENTS',
    FN_DA_WEB_CFUE: 'FN_DA_WEB_CFUE',
    FN_DL_AVAILABLE_DL: 'FN_DL_AVAILABLE_DL',
    FN_DL_DELETED: 'FN_DL_DELETED',
    FN_DL_PENDING_RQ: 'FN_DL_PENDING_RQ',
    FN_EPAYMENTS_CLIENT: 'FN_EPAYMENTS_CLIENT',
    FN_EPAYMENTS_EPROCUREMENT_SUPPLIER: 'FN_EPAYMENTS_EPROCUREMENT_SUPPLIER',
    FN_EPAYMENTS_SUPPLIER: 'FN_EPAYMENTS_SUPPLIER',
    FN_HELP: 'FN_HELP',
    FN_LOGIN_MANAGER: 'FN_LOGIN_MANAGER',
    FN_PREF_ENTREPRISE_PROFILE: 'FN_PREF_ENTREPRISE_PROFILE',
    FN_PREF_ESTAB_PROFILE: 'FN_PREF_ESTAB_PROFILE',
    FN_PREF_GENERAL: 'FN_PREF_GENERAL',
    FN_PREF_USER_PROFILE: 'FN_PREF_USER_PROFILE',
    FN_ROLLOUT_MATCHING_LEGACY: 'FN_ROLLOUT_MATCHING_LEGACY',
    FN_ROLLOUT_STATUS: 'FN_ROLLOUT_STATUS',
    FN_ROLLOUT_TEMPLATE_EDIT: 'FN_ROLLOUT_TEMPLATE_EDIT',
    FN_ROLLOUT_VOUCHER_SENT: 'FN_ROLLOUT_VOUCHER_SENT',
    FN_SUPPORT_DOWNLOADS: 'FN_SUPPORT_DOWNLOADS',
    FN_TPN_EBILLING_CLIENT: 'FN_TPN_EBILLING_CLIENT',
    FN_TPN_EBILLING_SUPPLIER: 'FN_TPN_EBILLING_SUPPLIER',
    FN_TPN_VCC_CLIENT: 'FN_TPN_VCC_CLIENT',
    FN_TPN_VCC_SUPPLIER: 'FN_TPN_VCC_SUPPLIER',
    FN_VCC_SEARCHER_CUSTOMER: 'FN_VCC_SEARCHER_CUSTOMER',
    FN_VCC_SEARCHER_SUPPLIER: 'FN_VCC_SEARCHER_SUPPLIER',
    FN_WBEPROC_IMPORT_INVOICE: 'FN_WBEPROC_IMPORT_INVOICE',
    FN_WBEPROC_MANUAL_INVOICE: 'FN_WBEPROC_MANUAL_INVOICE',
    FN_WBH_AUTO_DN: 'FN_WBH_AUTO_DN',
    FN_WBH_IMPORT_INVOICE: 'FN_WBH_IMPORT_INVOICE',
    FN_WBH_MANUAL_INVOICE: 'FN_WBH_MANUAL_INVOICE',
    FN_WBT_IMPORT_INVOICE: 'FN_WBT_IMPORT_INVOICE',
    FN_WBT_MANUAL_INVOICE: 'FN_WBT_MANUAL_INVOICE',
    HORECA_BILLING_FILE_IMP: 'HORECABILLINGFILEIMP',
    HORECA_BILLING: 'HORECABILLING',
    INVOICE_FROM_AUTODN: 'INVOICEFROMAUTODN',
    INVOICE_FROM_PO: 'INVOICEFROMPO',
    IS_SUPPLIER_ESTAB_MANAGER: 'IsSuppEstabManager',
    IS_SUPPLIER_ESTAB_MANAGED: 'IsSuppEstabManaged',
    LOGIN_EDITOR: 'LOGINEDITOR',
    MAIN_LOGIN: 'MainLogin',
    OWN_CREDIT: 'OwnCredit',
    PDF_BILLING: 'PDFBILLINGTRAVEL',
    ROOT_ENTERPRISE: 'RootEnterprise',
    SEND_ONLY_ARCHIVE: 'SENDONLYARCHIVE',
    SPONSOR: 'SPONSOR',
    SSO: 'SSO',
    TRAVEL_100_INVOICING: 'TRAVEL100INVOICING',
    TRAVEL_BILLING_FILE_IMP: 'TRAVELBILLINGFILEIMP',
    TRAVEL_BILLING: 'TRAVELBILLING',
    UNDOCUMENTED_ESTAB: 'UNDOCUMENTED_ESTAB',
    VIC_FACTURAS: 'VICFACTURAS',
    VIC: 'VIC',
    WEB_CFUE: 'WEBCFUE'
};
